import { render, staticRenderFns } from "./SubscriptionError.vue?vue&type=template&id=dc01fab4"
import script from "./SubscriptionError.vue?vue&type=script&lang=js"
export * from "./SubscriptionError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports